<template>
  <div
    :id="`popover-hover-button-${id}-${rank}-${index2}`"
    data-popover-trigger="hover"
    class="cursor-pointer border border-gray-300 text-left flex flex-row items-center hover:border-2 hover:border-gray-400"
    :class="{ 'h-24': condensed == undefined, 'h-16': condensed }"
    @mouseover="onHoverPopup(rank, index2, cell[week])"
  >
    <div
      class="w-full text-sm font-semibold h-full flex flex-row items-center px-3"
      :class="{ 'bg-green-100': cell[week] && cell[week].length > 0 && cell[week][0].state == 'DONE', 'bg-green-100': cell[week] && cell[week].length > 0 && cell[week][0].state == 'COMPLIANT', 'bg-red-100': cell[week] && cell[week].length > 0 && cell[week][0].state == 'NOT-COMPLIANT', 'bg-gray-100': cell[week] && cell[week].length > 0 && cell[week][0].state == 'NOT-DONE' }"
    >
      <div class="flex flex-row justify-between w-full">
        <div class="w-full flex flex-col items-center justify-start" v-if="cell[week].length > 0">
          <h1 v-if="cell[week][0].state == 'DONE'" class="w-full flex flex-row items-center justify-center text-lg">Effectué</h1>
          <h1 v-if="cell[week][0].state == 'COMPLIANT'" class="w-full flex flex-row items-center justify-center text-lg">CONFORME</h1>

          <h1 v-if="cell[week][0].state == 'NOT-COMPLIANT'" class="w-full flex flex-row items-center justify-center text-lg">NON CONFORME</h1>



          <h1 v-if="cell[week][0].state == 'NOT-DONE'" class="w-full flex flex-row font-normal items-center justify-center italic text-lg">{{ cell[week][0].reason_label }}</h1>

          <div class="flex flex-row items-center justify-start text-gray-600">
            <i class="fa-solid fa-user mr-1"></i>
            <div class=" ">
              {{ cell[week][0].user?.name }}
            </div>
          </div>
        </div>
        <div 
          v-if="cell[week].length > 100"
          class="w-full flex flex-col items-center justify-start"
        >
          <h1 class="w-full flex flex-row items-center justify-center text-lg">
            Effectué
          </h1>
          <div class="flex flex-row items-center justify-start text-gray-600">
            <div class=" "><i class="fa-solid fa-user"></i> :</div>
          </div>
        </div>
        <div 
          v-if="cell[week].length > 1"
          class="flex justify-center items-center right" 
        >
          <div class="bg-green-500 text-white rounded-full border border-gray-800 flex justify-center items-center p-2 font-bold text-xs w-6 h-6">+{{ cell[week].length - 1 }}</div>
        </div>
      </div>
    </div>
    <div
      :id="`popover-hover-menu-${id}-${rank}-${index2}`"
      data-popover
      role="tooltip"
      class="absolute z-10 invisible inline-block w-96 text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-300 rounded-lg shadow-sm opacity-0   "
    >
      <FileColDisplayCleaningPlan :items="cell[week]" />

      <div class="hidden py-1 bg-gray-50 border-t border-t-gray-300 text-xs justify-center font-normal h-full flex flex-row items-center px-3">
        <div class="cursor-pointer" @click="openDetails(cell)">
          <span>Voir le détail <i class="fa-solid fa-up-right-from-square pl-2 w-6" /></span>
        </div>
      </div>
      <div data-popper-arrow />
    </div>
  </div>
</template>

<script>
import { Popover } from "flowbite";

import FileColDisplayCleaningPlan from "@/components/five-col-cells/FileColDisplayCleaningPlan.vue";

export default {
  name: "CellTemperatureHumidity",

  components: {
    FileColDisplayCleaningPlan,
  },
  props: {
    cell: Object,
    week: String,
    index2: Number,
    id: String,
    condensed: Boolean,
    rank: Number,
    formatCell: Object,
  },

  data() {
    return {
      popupHoverSelection: null,
      comment: "",
    };
  },
  methods: {
    displayDate(a) {
      if (a == "") return "-";

      let date = new Date(a);

      // Options pour formater la date
      const options = {
        day: "numeric", // Jour du mois (21)
        month: "numeric", // Nom complet du mois (Novembre)
        year: "numeric", // Année sur 2 chiffres (24)
      };

      // Formater la date en français
      const formattedDate = new Intl.DateTimeFormat("fr-FR", options).format(date);

      return formattedDate;
    },
    limitTo2(a, max) {
      if (a == undefined) return [];
      if (!Array.isArray(a)) return [];

      if (a.length < max) return a;

      return a.slice(0, max);
    },
    formatDate(d) {
      if (d == undefined) return "";
      if (d == "") return "";
      let s = d.split("T");
      return s[0];
    },
    onHoverPopup(rank, index, items) {
 

      this.comment = "id =" + index;
      if (items == undefined) return;
      if (items.length == 0) return;

      if (this.popupHoverSelection == undefined) {
       

        // set the popover content elementpopover-default-pv2-28
        const $targetEl = document.getElementById("popover-hover-menu-" + this.id + "-" + rank + "-" + index);
        if ($targetEl == undefined) {
         

          return;
        }
        // set the element that trigger the popover using hover or click
        const $triggerEl = document.getElementById("popover-hover-button-" + this.id + "-" + rank + "-" + index);
        if ($triggerEl == undefined) {
          
          return;
        }
        // options with default values
        const options = {
          placement: "bottom",
          triggerType: "hover",
          offset: 10,
          // onHide: () => {
         
          // },
          // onShow: () => {
      
          //},
          // onToggle: () => {
        
          //},
        };

        // instance options object
        const instanceOptions = {
          id: "popover-hover-menu-" + this.id + rank + "-" + "-" + index, //'popover-hover',
          override: true,
        };

        this.popupHoverSelection = new Popover($targetEl, $triggerEl, options, instanceOptions);
      } else {
 
        if (this.popupHoverSelection != undefined) this.popupHoverSelection.show();
      }
    },
  },
};
</script>
